import { PostLoader } from "@circle-react/components/ProfileModalV3/Loader/Post";
import { SidebarLoader } from "@circle-react/components/ProfileModalV3/Loader/Sidebar";
import { TabBarLoader } from "@circle-react/components/ProfileModalV3/Loader/TabBar";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { CompassLoader } from "./CompassLoader";

export const Loader = ({ isFullPageView }: { isFullPageView?: boolean }) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) return <CompassLoader />;

  return (
    <>
      <SidebarLoader isFullPageView={isFullPageView} />
      <div
        className={classNames(
          "col-span-12 flex flex-col overflow-auto px-4 pb-9 md:col-span-8 md:p-8",
          {
            "!md:pl-14 pl-4": isFullPageView,
          },
        )}
      >
        <TabBarLoader />
        <div className="flex flex-col space-y-4">
          <PostLoader />
          <PostLoader />
          <PostLoader />
          <PostLoader />
        </div>
      </div>
    </>
  );
};
